import React from 'react';
import ReactHtmlParser from 'react-html-parser'; 
import { Svg } from '../../1_Atoms/Svg/Svg';
import { getBaseUrl } from '../../../utils';

export const Modal_50_50 = ({title, copy, image, imageMobile, imageAlt, isOpen, modalId, setIsModalOpen, ...props }) => {
    const [modalImage, setModalImage] = React.useState(window.innerWidth < 768?imageMobile:image);
    const imagePath = getBaseUrl() + process.env.REACT_APP_BASIC_CONTENT_PATH;
    const handleResize = () =>{
        if(window.innerWidth < 768){
            setModalImage(imageMobile);
        } else {
            setModalImage(image);
        }
    }
    window.addEventListener('resize', handleResize);
    
    return (
        <div className="mz-modal mz-modal--non-sticky-top mz-modal-fifty-fifty" id={modalId} aria-hidden={!isOpen}>
            <div className="mz-modal__inner mz-container">
                <div className="mz-modal__wrapper mz-full-width">
                    <div className="mz-modal__close">
                        <button
                            className="mz-modal-close-button reset"
                            aria-label="Close Modal"
                            onClick={() => {
                                document.querySelector('html').classList.remove('inactive');
                                setIsModalOpen(false)
                            }}
                        >
                            <Svg
                                colour="grey"
                                size={1.875}
                                svg_list="x"
                            />
                        </button>
                    </div>
                    <div className="mz-modal__content">
                        <div className="mz-5050">
                            <div className="mz-container unconstrained mz-5050-container full-width no-gutter-between-cols">
                                <div className="mz-5050-left mz-5050-content">
                                    <div className="mz-image-nolazy mz-image">
                                        <img src={`${imagePath}/accessories/${image}`} alt={imageAlt}/>
                                    </div>
                                </div>
                                <div className="mz-5050-right mz-5050-content">
                                    <div className="mz-5050-text-wrapper text--left">
                                        <h3 className="mz-5050__title">{title}</h3>
                                        <div className="paragraph">{ ReactHtmlParser (copy) }</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Modal_50_50;